import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const authAPI = {
    register: (email, password, name) => 
        api.post('/auth/register', { email, password, name }),
    
    login: (email, password) => 
        api.post('/auth/login', { email, password }),
};

export const testsAPI = {
    getAllTests: () => 
        api.get('/tests'),
    
    getTestDetails: (testId) => 
        api.get(`/tests/${testId}`),
    
    createTest: (testData) => 
        api.post('/tests', testData),
    
    checkPassword: (testPassword) =>
        api.post('/tests/check-password', { test_password: testPassword }),
    
    deleteTest: (testId) => 
        api.delete(`/tests/${testId}`),
    
    getSubmissions: (testId) => 
        api.get(`/tests/${testId}/submissions`),
    
    getSubmissionDetails: (testId, submissionId) => 
        api.get(`/tests/${testId}/submissions/${submissionId}`),
    
    deleteSubmission: (testId, submissionId) =>
        api.delete(`/tests/${testId}/submissions/${submissionId}`),
};

export const studentAPI = {
    accessTest: (testPassword) => 
        api.post('/student/access-test', { test_password: testPassword }),
    
    validateStudent: (testId, studentName) => 
        api.post('/student/validate-student', { test_id: testId, student_name: studentName }),
    
    submitTest: (testId, studentName, answers) => 
        api.post('/student/submit', { test_id: testId, student_name: studentName, answers }),
};

export default api;
